export const AUTH_QUERY_KEY = 'signing';

export const enum AuthModalQuery {
  LOGIN = 'login',
  SIGN = 'sign',
  RESTORE_PASSWORD = 'restore_password',
}

type AuthQueryType = 'login' | 'sign' | 'close' | 'restore';

export function createAuthQuery(type: AuthQueryType) {
  let value;

  switch (type) {
    case 'login':
      value = AuthModalQuery.LOGIN; break;
    case 'sign':
      value = AuthModalQuery.SIGN; break;
    case 'restore':
      value = AuthModalQuery.RESTORE_PASSWORD; break;
    case 'close':
      return '';
  }

  return `?${AUTH_QUERY_KEY}=${value}`;
}
